import "../../../styles/menu.scss";

import Icon, { iconColor, iconTypes } from "./Icon.jsx";
import { Localization, createLocalization } from "../util/localization.jsx";
import { clearModalAndDropDown, setDropDown, setModal } from "../actions/modal";

import AllNotificationsContainer from "../containers/AllNotificationsContainer.jsx";
import CalendarItem from "./CalendarItem.jsx";
import CurrentTime from "./CurrentTime.jsx";
import DropDown from "./DropDown";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import ReactMarkdown from "react-markdown";
import { connect } from "react-redux";
import { createReselector } from "../util/reselect";
import { logOut } from "../actions/authentication.js";
import { markNotificationAsConfirmed } from "../actions/notifications";
import moment from "moment";
import { setActiveOrder } from "../../kundeweb/actions/order.js";
import { withRouter } from "react-router-dom";

class MenuMobileLink extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.history.push(this.props.url);
        if (this.props.hideMobileMenu) {
            this.props.hideMobileMenu();
        }
    }

    render() {
        const {
            url,
            label,
            activePath
        } = this.props;

        const isActivePath = activePath.startsWith(url);
        const bold = isActivePath;

        return (
            <React.Fragment>
                <div className={"dropdown-menu-item"} onClick={this.onClick}>
                    <div className={`dropdown-menu-mobile-item-text noselect ${bold ? "bold" : ""}`} >
                        {label}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

MenuMobileLink.propTypes = {
    activePath: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    hideMobileMenu: PropTypes.func,
    url: PropTypes.string.isRequired,

};

class MenuMobileExpandItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expanded: this.props.activePath.startsWith(this.props.url)
        };

        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand(e) {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            expanded: !this.state.expanded,
        });
    }

    render() {
        const {
            children,
            url,
            label,
            activePath,
        } = this.props;

        const isActivePath = activePath.startsWith(url);

        return (
            <React.Fragment>
                <div className={"dropdown-menu-item border"} onClick={this.toggleExpand}>
                    <Icon type={iconTypes.arrowRight} className="dropdown-menu-item-icon" opacity={isActivePath ? 1.0 : 0.2} />
                    <div className={"dropdown-menu-mobile-item-text noselect bold"} >
                        {label}
                    </div>
                </div>
                {this.state.expanded && (
                    children
                )}
            </React.Fragment>
        );
    }
}

MenuMobileExpandItem.propTypes = {
    activePath: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    children: PropTypes.node,
    url: PropTypes.string,
};

class MenuMobileExpand extends React.PureComponent {
    render() {
        const {
            activePath,
            localization,
            logOut,
            hideMobileMenu,
            history,
            isBlockedCustomer,
            showFreshFood,
        } = this.props;
        return (
            <div className="dropdown-menu-mobile-wrapper">
                <MenuMobileExpandItem label={localization.text("menu", "dashboard")} url={"/dashboard"} activePath={activePath}>
                    <div className="dropdown-menu-mobile-sublist">
                        <MenuMobileLink label={localization.text("menu", "dashboard")} url={"/dashboard"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                    </div>
                </MenuMobileExpandItem>
                {!isBlockedCustomer &&(
                    <MenuMobileExpandItem label={localization.text("menu", "order")} url={"/order"} activePath={activePath}>
                        <div className="dropdown-menu-mobile-sublist">
                            <MenuMobileLink label={localization.text("menu", "products")} url={"/order/products"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                            <MenuMobileLink label={localization.text("menu", "campaigns")} url={"/order/campaigns"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />                            
                            <MenuMobileLink label={localization.text("menu", "lists")} url={"/order/lists"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                            { showFreshFood && (
                                <MenuMobileLink label={localization.text("menu", "freshFood")} url={"/order/freshfoodTemplate"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                            )}  
                        </div>
                    </MenuMobileExpandItem>
                )}
                <MenuMobileExpandItem label={localization.text("menu", "history")} url={"/history"} activePath={activePath}>
                    <div className="dropdown-menu-mobile-sublist">
                        <MenuMobileLink label={localization.text("history", "documents")} url={"/history/documents"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                        <MenuMobileLink label={localization.text("history", "tobacco")} url={"/history/tobacco"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                    </div>
                </MenuMobileExpandItem>
                <MenuMobileExpandItem label={localization.text("menu", "accountAndSettings")} url={"/account_settings"} activePath={activePath}>
                    <div className="dropdown-menu-mobile-sublist">
                        <MenuMobileLink label={localization.text("myAccount", "myAccount")} url={"/account_settings/my_account"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                        <MenuMobileLink label={localization.text("myAccount", "notifications")} url={"/account_settings/subscriptions"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                    </div>
                </MenuMobileExpandItem>
                <MenuMobileExpandItem label={localization.text("menu", "helpAndSupport")} url={"/help"} activePath={activePath}>
                    <div className="dropdown-menu-mobile-sublist">
                        <MenuMobileLink label={localization.text("menu", "faqAndMessage")} url={"/help/faq"} activePath={activePath} history={history} hideMobileMenu={hideMobileMenu} />
                    </div>
                </MenuMobileExpandItem>
                <div className="dropdown-menu-mobile-last" style={{ padding: "8px", display: "flow-root" }}>
                    <button className={"btn icon"} onClick={logOut} disabled={false}>
                        <Icon type={iconTypes.logout} />
                        {localization.text("menu", "logOut")}
                    </button>
                    <div className="right">
                        <button className={"btn icon"} onClick={hideMobileMenu} disabled={false}>
                            <Icon type={iconTypes.x} color={iconColor.red} />
                            {localization.text("menu", "closeMenu")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

MenuMobileExpand.propTypes = {
    activePath: PropTypes.string.isRequired,
    logOut: PropTypes.func.isRequired,
    hideMobileMenu: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    history: PropTypes.object.isRequired,
    isBlockedCustomer: PropTypes.bool.isRequired,
    showFreshFood : PropTypes.bool.isRequired,
};

class MenuDropdownItem extends React.PureComponent {
    constructor(props) {
        super(props);
    }


    render() {
        const {
            icon,
            label,
            onClick
        } = this.props;
        return (
            <div className="dropdown-menu-item" onClick={onClick}>
                <Icon type={icon} className="dropdown-menu-item-icon" />
                <div className={"dropdown-menu-item-text noselect"} >
                    {label}
                </div>
            </div>
        );
    }
}

MenuDropdownItem.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

class NotificationDropdownItem extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        if (this.props.notification && !this.props.notification.confirmedDate && !this.props.notification.displayPopup) {
            // If a notification which isn't a popup (and needs an explicit confirm action) is dismissed, mark it as read
            this.props.markNotificationAsConfirmed(this.props.notification.notificationId);
        }
    }

    render() {
        const {
            localization,
            notification: {
                body,
                confirmedDate,
                fromDate,
                subject,
                dismissedOnClient
            }
        } = this.props;

        const unread = (confirmedDate == null) && !dismissedOnClient;
        const icon = iconTypes.checkboxChecked;
        const now = moment();
        const diff = Math.max(0, now.diff(fromDate));

        let timeAgo;
        // if (diff < 15 * 60 * 1000) {
        //     timeAgo = localization.text("menu", "now");
        // } else if (diff < (60 * 60 * 1000)) {
        //     timeAgo = localization.text("menu", "xMinutesAgo", { minutes: moment.duration(diff).minutes() });
        // } else if (diff < (24 * 60 * 60 * 1000)) {
        //     timeAgo = localization.text("menu", "xHoursAgo", { hours: moment.duration(diff).hours() });
        if (diff < (24 * 60 * 60 * 1000))
        {
            timeAgo = localization.text("menu", "today", { hours: moment.duration(diff).hours() });
        } else {
            timeAgo = <React.Fragment><div>{fromDate.format("D.M.YYYY")}</div></React.Fragment>;
        }

        return (
            <div className={unread ? "notification dropdown-menu-item unread" : "notification dropdown-menu-item"}>
                <Icon type={icon} className="dropdown-menu-item-icon" />
                <div className={"noselect"} >
                    <div className="dropdown-menu-item-align">
                        <div className="dropdown-menu-item-text bold">
                            {subject}
                        </div>
                        <div className="dropdown-menu-right-text">
                            {timeAgo}
                        </div>
                    </div>
                    <div className="dropdown-menu-item-body">
                        <ReactMarkdown source={body} />
                    </div>
                </div>
            </div>
        );
    }
}

NotificationDropdownItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    markNotificationAsConfirmed: PropTypes.func.isRequired,
    notification: PropTypes.object.isRequired
};

class MenuItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
        };

        this.wrapperRef = React.createRef();

        this.onClick = this.onClick.bind(this);
        this.onClickHide = this.onClickHide.bind(this);
    }
    onClick() {
        const {
            setDropDown,
            children,
            width,
            dropDownShiftLeft,
            dropDownStyle,
        } = this.props;
        this.setState({
            active: !this.state.active,
        });

        if( !this.state.active ){
            setDropDown(
                <DropDown rect={this.wrapperRef.current.getBoundingClientRect()} style={{width:width||180}}  left = {dropDownStyle ? dropDownStyle.left : undefined } below={true} isDroppedDown={true} onComponentWillUnmount={this.onClickHide} shiftLeft={dropDownShiftLeft} setDropDown={setDropDown}>
                    {children}
                </DropDown>,
                true
            );
        } else {
            setDropDown(null);
        }
    }
    onClickHide(){
        this.setState({
            active: false,
        });
    }
    render() {
        const {
            icon,
            side,
            number,
            color,
            text,
        } = this.props;
        const className = `top_bar_item ${side} ${this.state.active ? "active_icon" : ""}`;
        const currentColor = this.state.active ? iconColor.white : color;
        return (
            <div className={className} onClick={this.onClick} ref={this.wrapperRef}>
                { text ? (
                    <div className="item item-icon notifications_icon" style={{marginTop: "-13px", textAlign: "center" }} >
                        <Icon type={icon} className="menu_icon noselect" color={currentColor} />
                        {number && (
                            <small>{number}</small>
                        )}
                        <div className="menu_text">{text} </div>
                    </div>)
                    :(
                        <div className="item item-icon notifications_icon" >
                            <Icon type={icon} className="menu_icon noselect" color={currentColor} />
                            {number && (
                                <small>{number}</small>
                            )}
                        </div>)
                }                
            </div>
        );
    }
}

MenuItem.propTypes = {
    activeMenu: PropTypes.string,
    children: PropTypes.node,
    dropDownStyle: PropTypes.object,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.number,
    text: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    side: PropTypes.string.isRequired,
    setDropDown: PropTypes.func,
    width: PropTypes.number,
    dropDownShiftLeft: PropTypes.bool,
    // Special color of the icon
    color: PropTypes.string
};
MenuItem.defaultProps = {
    dropDownShiftLeft: true,
};

const mapStateToProps = () => {
    const notificationsReselector = createReselector((notifications) => {
        const sorted = [...Object.values(notifications).map(n => ({
            ...n,
            fromDate: moment(n.fromDate)
        }))];

        sorted.sort((a, b) => b.fromDate.diff(a.fromDate));

        const NOTIFICATIONS_TO_SHOW = 6;

        const groupedNotifications = [];

        const currentDate = moment().startOf("date");
        let group = null;

        for (let i = 0; (i < NOTIFICATIONS_TO_SHOW && i < sorted.length); i++) {
            const n = sorted[i];
            const diff = moment.duration(currentDate.diff(n.fromDate));
            const daysAgo = Math.max(0, diff.days());
            const monthsAgo = Math.max(0, diff.months());
            const yearsAgo = Math.max(0, diff.years());

            if (!group || (yearsAgo !== group.yearsAgo) || (yearsAgo === 0 && monthsAgo !== group.monthsAgo) || (yearsAgo === 0 && monthsAgo === 0 && daysAgo !== group.daysAgo)) {
                group = {
                    daysAgo,
                    monthsAgo,
                    yearsAgo,
                    notifications: [n]
                };

                groupedNotifications.push(group);
            } else {
                group.notifications.push(n);
            }
        }

        const unreadCount = sorted.reduce((count, n) => count + ((n.confirmedDate || n.dismissedOnClient) ? 0 : 1), 0);

        return {
            groups: groupedNotifications,
            unreadCount
        };
    });

    return state => {
        return {
            deviceType: state.view.deviceType,
            innerWidth: state.view.innerWidth,
            localization: createLocalization(state),
            notifications: notificationsReselector(state.notifications.notifications),
            view: state.view,
            isBlockedCustomer: state.authentication.isBlockedCustomer,
            webEditOnlyTobacco: state.authentication.webEditOnlyTobacco,
            showFreshFood: state.authentication.showFreshFood,
            newSeasonDistrDates : state.authentication.newSeasonDistrDates || [],
            deliveryDates: state.delivery.dates.deliveryDates || [],
            width: state.view.innerWidth,
            activeOrder: state.order.active,
            
        };
    };
};

const mapDispatchToProps = {
    markNotificationAsConfirmed,
    logOut,
    setModal,
    setDropDown,
    clearModalAndDropDown,
    setActiveOrder,
};

class Menu extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            menu: null
        };

        this.clearScreen = this.clearScreen.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onClickLogout = this.onClickLogout.bind(this);
        this.onClickHideMobileMenu = this.onClickHideMobileMenu.bind(this);
        this.onSeeAllNotifications = this.onSeeAllNotifications.bind(this);
        this.onClickAccountAndSettings = this.onClickAccountAndSettings.bind(this);
        this.onClickHelpSupport = this.onClickHelpSupport.bind(this);
    }

    clearScreen() {
        this.props.clearModalAndDropDown();
    }
    onClick(e, whatMenu) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (whatMenu !== this.state.menu) {
            this.setState({ menu: whatMenu });
        } else {
            this.setState({ menu: null });
        }
    }
    onClickLogout() {
        const {
            history,
            logOut
        } = this.props;
        this.props.clearModalAndDropDown();
        logOut(history, "Logged out");
    }
    onClickHideMobileMenu() {
        this.props.clearModalAndDropDown();
    }
    onClickAccountAndSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.clearModalAndDropDown();
        this.props.history.push("/account_settings");
        this.setState({ menu: null });
    }
    onClickHelpSupport(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.clearModalAndDropDown();
        this.props.history.push("/help/faq/");
        this.setState({ menu: null });
    }

    onSeeAllNotifications(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.clearModalAndDropDown();
        this.props.setModal(<AllNotificationsContainer />);
        this.setState({ menu: null });
    }

    render() {
        const {
            deviceType,
            innerWidth,
            localization,
            notifications,
            history,
            setDropDown,
            isBlockedCustomer,
            activeOrder,
            width,
            deliveryDates,
            setActiveOrder,
            newSeasonDistrDates,
            showFreshFood,
            webEditOnlyTobacco,
        } = this.props;

        const path = this.props.location.pathname;
        const links = [
            {
                url: "/dashboard",
                urlTest: "/dashboard",
                label: localization.text("menu", "dashboard")
            }, {
                url: "/order/products",
                urlTest: "/order",
                label: localization.text("menu", "order")
            }, {
                url: "/history/documents",
                urlTest: "/history",
                label: localization.text("menu", "history")
            },
        ];
        const components = [];
        if(!webEditOnlyTobacco)
        {
            for (let i = 0; i < links.length; i++) {
                components[components.length] = (<div className={`top_bar_item left ${path.startsWith(links[i].urlTest, 0) ? "active" : ""}`} key={i}>
                    <Link className= { i===1 && isBlockedCustomer ? "item-disabled" : "item" } to={links[i].url} onClick={this.clearScreen} >{links[i].label}</Link>
                </div>);
            }   
        }

        return (
            
            <div className="top_body">
                <div id="top_bar">
                    {deviceType !== "xs" ? ( 
                        <React.Fragment>
                            {components}
                            
                            <div className="top_bar_item right" onClick={this.onClickLogout}>
                                <div className="item item-icon"><Icon type={iconTypes.logout} className="menu_icon" /></div>
                            </div>
                            {!webEditOnlyTobacco &&
                            <MenuItem icon={iconTypes.account} side="right" onClick={this.onClick} name="account" activeMenu={this.state.menu} width={200} setDropDown={setDropDown}>
                                <MenuDropdownItem icon={iconTypes.account} onClick={this.onClickAccountAndSettings} label={localization.text("menu", "accountAndSettings")} url={"/account_settings"} />
                                <MenuDropdownItem icon={iconTypes.boxQuestion} onClick={this.onClickHelpSupport} label={localization.text("menu", "helpAndSupport")} url="/help/faq/"/>
                                <MenuDropdownItem icon={iconTypes.message} onClick={this.onClickHelpSupport} label={localization.text("menu", "messageUs")} url="/help/faq/"/>
                            </MenuItem>
                            }
                            {!webEditOnlyTobacco &&
                            <MenuItem icon={iconTypes.notification} side="right" onClick={this.onClick} name="notification" activeMenu={this.state.menu} number={notifications.unreadCount > 0 ? notifications.unreadCount : undefined} width={375} setDropDown={setDropDown}>
                                {
                                    notifications.groups.map((group, idx) => (
                                        <React.Fragment key={idx}>
                                            <div className="menu-notification-time-ago">{group.yearsAgo > 0 ? localization.text("menu", "xYearsAgo", { years: group.yearsAgo }) : (group.monthsAgo > 0 ? localization.text("menu", "xMonthsAgo", { months: group.monthsAgo }) : group.daysAgo > 0 ? localization.text("menu", "xDaysAgo", { days: group.daysAgo }) : localization.text("menu", "today"))}</div>
                                            {group.notifications.map(notification => (
                                                <NotificationDropdownItem key={notification.notificationId} notification={notification} localization={localization} markNotificationAsConfirmed={this.props.markNotificationAsConfirmed} />
                                            ))}
                                        </React.Fragment>
                                    ))
                                }
                                <div className="dropdown-menu-item-button">
                                    <button className="btn" onClick={this.onSeeAllNotifications}>{localization.text("menu", "seeAllNotifications")}</button>
                                </div>
                            </MenuItem>
                            }
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <MenuItem icon={iconTypes.menu} side="left" onClick={this.onClick} name="menu" activeMenu={this.state.menu} width={innerWidth} setDropDown={setDropDown} dropDownShiftLeft={false}>
                                <MenuMobileExpand activePath={path} localization={localization} logOut={this.onClickLogout} hideMobileMenu={this.onClickHideMobileMenu} history={history} isBlockedCustomer={isBlockedCustomer} showFreshFood={showFreshFood}/>
                            </MenuItem>
                            <div className="top_bar_item left current-time-wrapper ">
                                <CurrentTime /> 
                            </div>                            
                            <MenuItem text={localization.text("dashboard","calendar")} icon={newSeasonDistrDates.length>0? iconTypes.calendarWarning : iconTypes.calender} name="calendar" width={innerWidth} side="left" onClick={this.onClick} setDropDown={setDropDown} activeMenu={this.state.menu} dropDownShiftLeft={false} isDroppedDown={true} dropDownStyle={{ width: `${innerWidth}px`, right: "auto", left: "0" }} >
                                <CalendarItem deviceType={deviceType} activeOrder={activeOrder} width={width} setDropDown={setDropDown} localization={localization} deliveryDates={deliveryDates} setActiveOrder={setActiveOrder} history={history} newSeasonDistrDates = {newSeasonDistrDates}/>   
                            </MenuItem>                              
                            <MenuItem icon={iconTypes.notification} width={innerWidth} side="right" onClick={this.onClick} name="notification" activeMenu={this.state.menu} number={notifications.unreadCount > 0 ? notifications.unreadCount : undefined} dropDownStyle={{ width: `${innerWidth}px`, right: "0", left: "auto" }} setDropDown={setDropDown}>
                                {
                                    notifications.groups.map((group, idx) => (
                                        <React.Fragment key={idx}>
                                            <div className="menu-notification-time-ago">{group.yearsAgo > 0 ? localization.text("menu", "xYearsAgo", { years: group.yearsAgo }) : (group.monthsAgo > 0 ? localization.text("menu", "xMonthsAgo", { months: group.monthsAgo }) : group.daysAgo > 0 ? localization.text("menu", "xDaysAgo", { days: group.daysAgo }) : localization.text("menu", "today"))}</div>
                                            {group.notifications.map(notification => (
                                                <NotificationDropdownItem key={notification.notificationId} notification={notification} localization={localization} markNotificationAsConfirmed={this.props.markNotificationAsConfirmed} />
                                            ))}
                                        </React.Fragment>
                                    ))
                                }
                                <div className="dropdown-menu-item-button">
                                    <button className="btn" onClick={this.onSeeAllNotifications}>{localization.text("menu", "seeAllNotifications")}</button>
                                </div>
                            </MenuItem>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}
Menu.propTypes = {
    deviceType: PropTypes.string,
    innerWidth: PropTypes.number.isRequired,
    location: PropTypes.object,
    localization: Localization.propTypes.isRequired,
    markNotificationAsConfirmed: PropTypes.func.isRequired,
    notifications: PropTypes.shape({
        groups: PropTypes.array.isRequired,
        unreadCount: PropTypes.number.isRequired
    }).isRequired,
    view: PropTypes.object,
    history: PropTypes.object,
    logOut: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    clearModalAndDropDown: PropTypes.func.isRequired,
    isBlockedCustomer: PropTypes.bool.isRequired,
    deliveryDates: PropTypes.array,
    width: PropTypes.number,
    setActiveOrder: PropTypes.func,
    newSeasonDistrDates : PropTypes.array.isRequired,
    activeOrder: PropTypes.object.isRequired,
    showFreshFood: PropTypes.bool.isRequired,
    webEditOnlyTobacco: PropTypes.bool.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
